import { render, staticRenderFns } from "./PatientInfoCard.vue?vue&type=template&id=8324ac5c&"
import script from "./PatientInfoCard.vue?vue&type=script&lang=js&"
export * from "./PatientInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports